export default {
  title: "Provider Tax Details",
  edit_info: "Edit Info",
  title_placeholder_empty: "No info available",
};
